import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router'
import { motion } from 'framer-motion'
import { EditCollectionDetailsForm } from '@/components/collections/forms/EditCollectionDetailsForm'

// Define the route and attach the page component
export const Route = createFileRoute('/collections_/$id/edit-details')({
    component: EditCollectionDetailsPage,
})

function EditCollectionDetailsPage() {
    const { id } = useParams({ from: '/collections_/$id/edit-details' })
    const navigate = useNavigate()

    const handleSave = () => {
        navigate({ to: `/collections/${id}`, replace: true })
    }

    const handleCancel = () => {
        navigate({ to: `/collections/${id}`, replace: true })
    }

    return (
        <motion.div
            className="relative mx-auto h-[100dvh] max-w-md overflow-y-auto pb-36 md:max-w-2xl"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
        >
            <EditCollectionDetailsForm
                collectionId={id}
                onSave={handleSave}
                onCancel={handleCancel}
                showBackButton={true}
            />
        </motion.div>
    )
}
